import { render, staticRenderFns } from "./ReleaseNotesPopup.vue?vue&type=template&id=11ed1bdc&scoped=true"
import script from "./ReleaseNotesPopup.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesPopup.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesPopup.vue?vue&type=style&index=0&id=11ed1bdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed1bdc",
  null
  
)

export default component.exports